export default __webpack_public_path__ + "static/media/ls.5a5e280c.jpg";